import React, { useContext, useRef } from "react";
import { PhotoManagerContext } from ".";
import { usePopupClickOutside } from "../../../hooks/usePopupClickOutside";
const alertIcon = require("../../ManagePrepaidCustomers/components/images/alert.svg");

interface ConfirmAbortUploadModalProps {
  onContinueUpload: () => void;
  onAbortUpload: () => void;
}

const ConfirmAbortUploadModal: React.FC<ConfirmAbortUploadModalProps> = ({
  onContinueUpload,
  onAbortUpload
}) => {
  const context = useContext(PhotoManagerContext);
  const popupRef = useRef<HTMLDivElement>(null);
  usePopupClickOutside(popupRef, () => onContinueUpload());

  return (
    <div>
      <div
        id="filter-dialog"
        className="modal fade in geo-modal geo-modal--show geo-modal--small uploader-modal"
        role="dialog"
        style={{ zIndex: context?.isMobile ? "1000001" : "1055" }}
      >
        <div className="modal-dialog filter-dialog-content ws-abort-uploader-modal" ref={popupRef}>
          <div className="modal-header">
            &nbsp;
            <button
              type="button"
              className="close confirm-close"
              onClick={onContinueUpload}
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="geo-modal__header geo-modal--warning-bg">
            <img
              className="geo-modal__warn-icon"
              src={alertIcon}
              alt="exclamation-warn"
            />
            <h3>Upload In Progress</h3>
          </div>

          <div className="modal-body">
            <span>
              Your upload is currently in progress. If you leave now, the upload
              will be aborted.
            </span>
          </div>
          <div className="modal-footer geo-modal__actions dont-break ws-delete-footer-btns">
            <button
              className="geo-btn geo-btn--link geo-btn--caps"
              onClick={onContinueUpload}
            >
              Continue Upload
            </button>
            <button
              className="geo-btn geo-btn--secondary geo-btn--caps"
              onClick={onAbortUpload}
            >
              Abort Upload
            </button>
          </div>
        </div>
      </div>

      <div
        className="modal-backdrop fade in"
        style={{ zIndex: context?.isMobile ? "1000000" : "1054" }}
      />
    </div>
  );
};

export default ConfirmAbortUploadModal;
